import React, { useState } from "react"
import arrowLeftIcon from "./images/arrow-left.svg"
import presetMark from "./images/preset-mark.svg"
import Button from "components/ui/Button"
import SignUpButton from "components/ui/SignUpButton"

function NavMobile({ items, trackSignupButtonClick }) {
  const [activeItem, setActiveItem] = useState(null)

  const navItems = activeItem ? activeItem.items : items

  function BackButton() {
    return (
      <button
        className="absolute top-0 left-0 inline-flex items-center p-4 text-base font-medium text-black"
        onClick={() => setActiveItem(null)}
        type="button"
      >
        <img className="mr-1 h-3" src={arrowLeftIcon} alt="Arrow left" />
        Main Menu
      </button>
    )
  }

  function Item(item) {
    const classNames = "text-2xl font-bold text-black hover:text-lush"
    const { label, path, items: subItems } = item
    if (subItems && subItems.length > 0) {
      return (
        <Button className={classNames} onClick={() => setActiveItem(item)}>
          {label}
        </Button>
      )
    }
    return (
      <Button className={classNames} href={path}>
        {label}
      </Button>
    )
  }

  return (
    <div className="nav-mobile">
      <img
        className="absolute bottom-0 left-0"
        src={presetMark}
        alt="Preset mark"
      />
      {activeItem && <BackButton />}
      <ul className="relative z-30 flex flex-col items-center space-y-6">
        {navItems.map((props) => (
          <Item {...props} />
        ))}
        {!activeItem && (
          <li>
            <SignUpButton
              size="small"
              trackClick={`${trackSignupButtonClick} (mobile)`}
            >
              Try for Free
            </SignUpButton>
          </li>
        )}
      </ul>
    </div>
  )
}

export default NavMobile
